import { css } from 'styled-components';

export const backgroundBlueHorizontalGradient = css`
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.color.blue} 0%,
    ${({ theme }) => theme.color.blueLight} 100%
  );
`;
